import React, { useEffect } from "react";
import SB_LEARNING_CATALYST from "Assets/Images/sb_learning_catalyst.png";

import useAnalytics from "Hooks/useAnalytics";
import { ANALYTICS_EVENTS } from "Utils/analytics";
const ANALYTICS_FROM = "learning_catalyst";
const ANALYTICS_EVENT = ANALYTICS_EVENTS.LEARNING_CATALYST.VIEWED;

const SbLearningCatalyst= () => {
  const track = useAnalytics(ANALYTICS_FROM);
  // This screen has no Mixpanel coverage of its own; the automatic
  // pageview only records the URL, not that the module was reached.
  useEffect(() => {
    track(ANALYTICS_EVENT);
  }, [track]);

  return (
    <div className="skills-Bridger">
      <img src={SB_LEARNING_CATALYST} width={"100%"} alt="Learning Catalyst"></img>
      </div>
  );
};

export default SbLearningCatalyst;